import { Formik, FormikConfig } from 'formik';

export const Form = <Values extends {}>(props: FormikConfig<Values>) => (
  <Formik {...props}>
    {(formikProps) =>
      typeof props.children === 'function'
        ? <form onSubmit={formikProps.handleSubmit}>{props.children(formikProps)}</form>
        : <form onSubmit={formikProps.handleSubmit}>{props.children}</form>
    }
  </Formik>
);
